import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { LaborManagerCreateActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class LaborManagerCreateEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getLaborManagerCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LaborManagerCreateActions.getLaborManagerCreate),
      switchMap((action) =>
        this.onboardingProductsService.getLaborManagerCreate(action.request).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
            LaborManagerCreateActions.getLaborManagerCreateSucess({ response: res })
          ),
          catchError((error) =>
            of(
              LaborManagerCreateActions.getLaborManagerCreateError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );
}
